/**
 * Error codes for which the W11 error message should remain visible
 * (duration=0 in <ErrorMessage>) until the user acts on it. These are
 * codes representing a user-actionable state — quota exhausted,
 * invalid params, ownership violation — not transient transport errors.
 *
 * Mirrors features/data-cloud/utils/cloudPersistentErrorCodes.ts from W10.
 */

export const TRAINING_PERSISTENT_ERROR_CODES: ReadonlySet<string> = new Set([
  'TRAINING_LIMIT_EXCEEDED',
  'PROCESSING_LIMIT_EXCEEDED',
  'STORAGE_LIMIT_EXCEEDED',
  'FORBIDDEN',
  'INVALID_MODEL_PARAMS',
  'INSUFFICIENT_DATA',
  'MODEL_NOT_FOUND',
  'SCALER_NOT_FOUND',
]);

export function isTrainingPersistentErrorCode(code: string | undefined | null): boolean {
  if (!code) return false;
  return TRAINING_PERSISTENT_ERROR_CODES.has(code);
}
